/**
 * useCancelLeadRequest Hook
 *
 * Hook for cancelling a lead request by updating its status
 */
import { useState, useCallback } from 'react';
import { advisoryService } from 'services/advisoryService';
import { useToast } from 'hooks/useToast';
import { LeadRequestStatus } from 'types/leadRequestsTypes';

interface UseCancelLeadRequestReturn {
  cancelRequest: (id: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export const useCancelLeadRequest = (): UseCancelLeadRequestReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { toastSuccess, toastError } = useToast();

  const cancelRequest = useCallback(
    async (id: string): Promise<boolean> => {
      setLoading(true);
      setError(null);
      try {
        await advisoryService.updateLeadRequest(id, { status: LeadRequestStatus.CANCELED });
        toastSuccess('Solicitação cancelada com sucesso!');
        setLoading(false);
        return true;
      } catch (err: any) {
        const errorMessage = err.response?.data?.message || 'Falha ao cancelar solicitação';
        setError(errorMessage);
        toastError(errorMessage);
        setLoading(false);
        return false;
      }
    },
    [toastSuccess, toastError]
  );

  return {
    cancelRequest,
    loading,
    error,
  };
};
